// extracted by mini-css-extract-plugin
export default {"container":"styles_container__kfQ3z","title":"styles_title__TyOyH","backgroundLinie":"styles_backgroundLinie__4v2TH","row":"styles_row__dQrHK"};